import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/home/vsts/work/1/s/components/layout/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterSection"] */ "/home/vsts/work/1/s/components/layout/sections/footer.tsx");
